import { httpV2 } from "@/api";

/**
 * Cria as configurações construtivas do ativo.
 * @param {Object} assetConfiguration Configuração construtiva.
 */
const CreateKinematicConfiguration = function(assetConfiguration)
{
	return httpV2.post("/KinematicParameters", assetConfiguration);
};

/**
 * Solicita as confIgurações construtivas do ativo.
 * @param {number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 * @returns Configuração construtiva do ativo.
 */
const GetKinematicConfiguration = function(monitoringElementId)
{
	return httpV2.get(`/KinematicParameters/${monitoringElementId}`);
};

/**
 * Solicita as turbinas que possuem configurações cinemáticas.
 * @param {number} companyId Identificador da empresa. 
 * @returns Dados das turbinas que possuem configurações cinemáticas.
 */
const GetConfiguredTurbines = function(companyId)
{
	return httpV2.get(`/KinematicParameters/${companyId}/ConfiguredTurbines`);
};

/**
 * Replica configurações cinemáticas de um aerogerador configurado.
 * @param {Object} configurationReplication dados de configuração para replicação. 
 * @returns Id das turbinas na qual passaram pela replicação.
 */
const ReplicateKinematicConfiguration = function(configurationReplication)
{
	return httpV2.post("/KinematicParameters/Replications", configurationReplication);
};

export default {
	CreateKinematicConfiguration, GetKinematicConfiguration, GetConfiguredTurbines, ReplicateKinematicConfiguration
};